import { nwccDomain } from "@js/nwcc-domains.js";

const basinMetaBaseUrl = `${nwccDomain}/awdb/basin-defs/site-lists`;

export async function getStateBasins(state, baseUrl = basinMetaBaseUrl) {
    const url = `${baseUrl}/${state.toLowerCase()}_parents.json`;
    const response = await fetch(url);
    const jsonData = await response.json();
    return jsonData;
}
